import { OccConfig, OccEndpoints } from '@spartacus/core';

export const registrationApiConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        registrationParams: 'customer-register/user-params',
      } as OccEndpoints,
    },
  },
};
